// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Q4DI","col":"styles_col__2-jyb","fulfillmentStatus":"styles_fulfillmentStatus__Pvi3O","emailCol":"styles_emailCol__3jyvV"};